import React from "react";
import useClientOptions from "../hooks/useClientOptions";

/** Optional client a business lead belongs to. Lists active clients plus the current one. */
export default function LeadClientSelect({ value, onChange, label = "Client" }) {
  const clients = useClientOptions();
  const current = String(value || "");
  const options = clients.filter((c) => c.isActive || c.id === current);

  return (
    <div className="form-group">
      <label>{label}</label>
      <select value={current} onChange={(e) => onChange(e.target.value)}>
        <option value="">No client</option>
        {options.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
            {c.domainName ? ` · ${c.domainName}` : ""}
            {c.isActive ? "" : " (Inactive)"}
          </option>
        ))}
      </select>
    </div>
  );
}
